import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_DESPESASGERAIS_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodos(filtro) {
        return axiosJwt
            .get(`${api}/despesasgerais/fornecedores/despesas?status=${filtro.status != null ? filtro.status : ''}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterFiltros() {
        return axiosJwt
            .get(`${api}/despesasgerais/fornecedores/despesas/filtros`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(despesaId) {
        return axiosJwt
            .get(`${api}/despesasgerais/fornecedores/despesas/${despesaId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDespesasOpcoes() {
        return axiosJwt
            .get(`${api}/despesasgerais/fornecedores/despesas/opcoes`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterFornecedor(cpfcnpjcodcfo) {
        return axiosJwt
            .get(`${api}/despesasgerais/fornecedores/despesas/fornecedor/${cpfcnpjcodcfo}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirDespesa(despesaDto) {
        return axiosJwt
            .post(`${api}/despesasgerais/fornecedores/despesas/inserir`, despesaDto)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarDespesa(despesaDto) {
        return axiosJwt
            .put(`${api}/despesasgerais/fornecedores/despesas/atualizar`, despesaDto)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    comprometer(despesaId) {
        return axiosJwt
            .patch(`${api}/despesasgerais/fornecedores/despesas/${despesaId}/comprometer`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    solicitarAprovacaoDemandante(despesaId) {
        return axiosJwt
            .patch(`${api}/despesasgerais/fornecedores/despesas/${despesaId}/solicitaraprovacao`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    devolver(despesaId) {
        return axiosJwt
            .patch(`${api}/despesasgerais/fornecedores/despesas/${despesaId}/devolver`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    ajustarBoleto(despesaBoletoDto) {
        return axiosJwt
            .post(`${api}/despesasgerais/fornecedores/despesas/${despesaBoletoDto.despesaId}/ajustarboleto`, despesaBoletoDto)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTimeLine(despesaId) {
        return axiosJwt
            .get(`${api}/despesasgerais/fornecedores/despesas/${despesaId}/timeline`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    }
}